import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NotificationService } from '@services/notification.service';

@Component({
  selector: 'app-notification-modal-dialog',
  templateUrl: './notification.component.html',
  styleUrls: [
    './notification.component.scss',
    './notification-types.component.scss',
    './notification-close-modal.component.scss',
  ],

  changeDetection: ChangeDetectionStrategy.Eager,

  standalone: false,
})
export class NotificationComponent implements OnInit {
  constructor(public notify: NotificationService) {}

  ngOnInit(): void {}
}
